import React, { useState } from "react";

import { useNavigate } from "react-router-dom";



import imageOne from "../resource/contact/F40 (2).png";
import imageOtwo from "../resource/contact/F40.png";
import imageThree from "../resource/contact/5.png";

import imageFive from "../resource/contact/4.png";
import imageSix from "../resource/contact/6.png";

import TitleChnage from "../Hook/TitleChnage";
import bottomImage from "../resource/aboutus/History pack/F2.png";

const ContactUs = () => {
  TitleChnage("Contact Us");

  const navigate = useNavigate();

  const handleClick = (event) => {
    const pathMap = {
      generalForm: "/generalForm",
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  return (
    <div className="page aboutus-page-container contactus-page">
      <img src={imageOne} alt="" className="left-imge-fixed" />
      <img src={imageOtwo} alt="" className="right-imge-fixed" />

      <header>
        
        <div className="title">
          <h1>Contact Us</h1>
          <img src={imageThree} width={300} />
        </div>
      </header>

      <h1 className="font-second dark-gold  p-4 text-center">
        Postal address
      </h1>
      <h1 className="font-second dark-gold mt-4 p-4 text-center">
        Bhaddeka Vihari Monastery & Meditation Center
      </h1>

      <p className=" h4">1855 Westernport Road,</p>
      <p className="h4">Ripplebrook,</p>
      <p className="h4">VIC 3818</p>
      <p className="h4">Australia</p>

      <div className="contactus ">
        <div className="left-c">
          <h1 className="meditate-info text-black dark-gold mt-4 p-4 "> Phone</h1>
          <p className="text-left p-4 mt-4 title-text">
            <b>Monastery</b>: 035608 0918 / 0459 729 738
          </p>
          <p className="text-left p-4 title-text">
            <b>Mr Gamini</b>: 0422 069 359
          </p>

          <h1 className="meditate-info text-black dark-gold mt-4 p-4 "> Email</h1>
          <p className="text-left p-4 mt-4 title-text">
            <b>General enquiries</b>: info@bvp.org.au
          </p>
          <p className="text-left p-4 title-text">
            <b>Membership enquires</b>:info@bvp.org.au
          </p>
          <p className="text-left p-4 title-text">
            <b>Retreat enquiries</b>:info@bvp.org.au
          </p>
        </div>

        <div className="right-c">
          <div className="button-g">
            <img
              src={imageFive}
              alt=""
              width={250}
              id=""
              onClick={handleClick}
            />
            <img
              src={imageSix}
              alt=""
              width={250}
              id="generalForm"
              onClick={handleClick}
              className="curser-pointer"
            />
          </div>
        </div>
      </div>

      <div>
        <div className="box bottom-img-container">
        <img src={bottomImage} alt="bottom-image"  className="bottom-imge " />
      </div>
      </div>
    </div>
  );
};

export default ContactUs;
